import { Box, Typography, Button, Paper } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import AppDialog from "./Dialog/AppDialog";
import HelpOutlinedIcon from "@mui/icons-material/HelpOutlined";

export default function DynamicExcelHelpModal({
  open,
  onClose,
  title,
  description,
  columns = [],
  example = [],
}) {
  const theme = useTheme();
  const isDark = theme.palette.mode === "dark";

  const paperBg = isDark ? "rgba(255,255,255,0.04)" : "rgba(255,255,255,0.55)";
  const paperBorder = isDark ? "rgba(255,255,255,0.08)" : "rgba(0,0,0,0.08)";
  const itemBg = isDark ? "rgba(255,255,255,0.06)" : "rgba(255,255,255,0.72)";
  const tableBorder = isDark ? "rgba(255,255,255,0.08)" : "rgba(0,0,0,0.10)";
  const tableHeaderBg = isDark ? "rgba(255,255,255,0.06)" : "rgba(0,0,0,0.04)";
  const tableBg = isDark ? "rgba(255,255,255,0.03)" : "#fff";

  return (
    <AppDialog
      open={open}
      onClose={onClose}
      title={title}
      subtitle={description}
      icon={<HelpOutlinedIcon />}
      maxWidth="md"
      fullWidth
      fullScreenMobile
      stickyHeader
      contentSx={{
        p: { xs: 1.5, sm: 2 },
        background: "transparent",
      }}
      actions={
        <Button
          variant="contained"
          onClick={onClose}
          sx={{
            borderRadius: 2.5,
            fontWeight: 900,
            textTransform: "none",
            px: 3,
          }}
        >
          Entendido
        </Button>
      }
    >
      <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
        <Paper
          variant="outlined"
          sx={{
            p: 2,
            borderRadius: 3,
            background: paperBg,
            border: `1px solid ${paperBorder}`,
            boxShadow: "none",
          }}
        >
          <Typography sx={{ fontWeight: 900, mb: 1 }}>
            Estructura requerida
          </Typography>

          <Typography variant="body2" sx={{ opacity: 0.78, mb: 1.5 }}>
            El archivo debe contener las siguientes columnas, sin encabezados:
          </Typography>

          <Box sx={{ display: "grid", gap: 1 }}>
            {columns.map((col, index) => (
              <Box
                key={index}
                sx={{
                  px: 1.4,
                  py: 1,
                  borderRadius: 2.5,
                  background: itemBg,
                  border: `1px solid ${paperBorder}`,
                }}
              >
                <Typography sx={{ fontWeight: 800, fontSize: 14 }}>
                  {index + 1}. {col}
                </Typography>
              </Box>
            ))}
          </Box>
        </Paper>

        {example.length > 0 && (
          <Paper
            variant="outlined"
            sx={{
              p: 2,
              borderRadius: 3,
              background: paperBg,
              border: `1px solid ${paperBorder}`,
              boxShadow: "none",
            }}
          >
            <Typography sx={{ fontWeight: 900, mb: 1.5 }}>
              Ejemplo correcto
            </Typography>

            <Box
              sx={{
                overflowX: "auto",
                borderRadius: 2.5,
                border: `1px solid ${tableBorder}`,
                background: tableBg,
              }}
            >
              <Box sx={{ minWidth: "max-content" }}>
                <Box
                  sx={{
                    display: "grid",
                    gridTemplateColumns: `repeat(${example.length}, minmax(160px, 1fr))`,
                    background: tableHeaderBg,
                    borderBottom: `1px solid ${tableBorder}`,
                  }}
                >
                  {example.map((_, idx) => (
                    <Box
                      key={`col-${idx}`}
                      sx={{
                        px: 1.2,
                        py: 0.8,
                        textAlign: "center",
                        fontWeight: 800,
                        fontSize: 13,
                        borderRight:
                          idx < example.length - 1
                            ? `1px solid ${tableBorder}`
                            : "none",
                      }}
                    >
                      {String.fromCharCode(65 + idx)}
                    </Box>
                  ))}
                </Box>

                <Box
                  sx={{
                    display: "grid",
                    gridTemplateColumns: `repeat(${example.length}, minmax(160px, 1fr))`,
                  }}
                >
                  {example.map((value, idx) => (
                    <Box
                      key={idx}
                      sx={{
                        px: 1.2,
                        py: 1,
                        minHeight: 44,
                        display: "flex",
                        alignItems: "center",
                        borderRight:
                          idx < example.length - 1
                            ? `1px solid ${tableBorder}`
                            : "none",
                        borderBottom: `1px solid ${tableBorder}`,
                        fontSize: 14,
                        fontFamily: "inherit",
                      }}
                    >
                      <Typography variant="body2" sx={{ fontWeight: 600 }}>
                        {value}
                      </Typography>
                    </Box>
                  ))}
                </Box>
              </Box>
            </Box>
          </Paper>
        )}
      </Box>
    </AppDialog>
  );
}
